// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3NMxK","messages":"Chat_messages__1sYMG","dateDivider":"Chat_dateDivider__x39M8"};